"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverInputItem = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Grid_1 = tslib_1.__importDefault(require("@material-ui/core/Grid"));
var Typography_1 = require("../../Typography");
exports.PopoverInputItem = function (_a) {
    var label = _a.label, className = _a.className, children = _a.children;
    return (react_1.default.createElement(Grid_1.default, { container: true, alignItems: "center", wrap: "nowrap", className: className },
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, md: 6 },
            react_1.default.createElement(Typography_1.Label, null, label)),
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, md: 6 }, children)));
};
exports.PopoverInputItem.displayName = 'FOS_PopoverInputItem';
